import React from "react";
import { useState } from "react";
import { Container, Row, Col, Button, FormFeedback, Form, Input } from "reactstrap";
import axios from 'axios';
import Swal from 'sweetalert2'
import ReactLoading from 'react-loading';


// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Section Title
import SectionTitleContact from "../common/section-title-contact";

const ContactUs = () => {
  const [cargando, setCargando] = useState(false);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: '',
      email: '',
      subject: '',
      comments: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, ingresa tu nombre"),
      email: Yup.string().required("Por favor, ingresa tu correo electrónico"),
      comments: Yup.string().required("Por favor, ingresa el asunto"),
    }),
    onSubmit: (values) => {
      setCargando(true)
      console.log("values", values);
      const nombre = values.name;
      const correo = values.email;
      const mensaje = values.comments;
      //Cambiar estos datos para cada pagina y su respectivo contacto
      const nombreProp = 'Miguel Antonio';
      const correoProp = 'mchacon@ipme.com.mx';
      const pagina = 'https://ipme.com.mx/';//Nombre de la pagina xd

      // Crear un objeto con los datos a enviar
      const data = {
        nombre,
        correo,
        mensaje,
        nombreProp,
        correoProp,
        pagina
      };

      console.log(data)
      // Realizar la solicitud POST utilizando Axios
      axios.post('https://taeconta.com/api/public/api/correos/publicos', data)
        .then(response => {
          console.log('Correo enviado con éxito:', response.data);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Correo enviado exitosamente",
            showConfirmButton: false,
            timer: 1500
          });
          setCargando(false)
          // clearState(e)
        })
        .catch(error => {
          console.error('Error al enviar el correo:', error);
          Swal.fire(
            "Error al enviar el correo",
            error.message + ", " + error.response.data.message,
            "error"
          );
          setCargando(false)
          // clearState(e)
        });
    }
  });


  return (
    <React.Fragment>
      <section className="section " id="contact">
        <Container>
          {/* Render section title */}
          <SectionTitleContact
            title="Contáctanos"
            description="Nuestros valores son la responsabilidad, la confianza, la amabilidad, el respeto, la sencillez, la pasión. Si tienes alguna duda, comentario o sugerencia, no dudes en contactarnos."
          />

          <Row>
            <Col lg="4">
              <div className="mt-4 pt-4">
                <p className="mt-4">
                  <span className="h4">Miguel Antonio Chacón Vea:</span>
                  <br />{" "}
                  <a href="mailto:mchacon@ipme.com.mx"><strong>Correo:</strong> mchacon@ipme.com.mx</a><br></br>
                  <a href="tel:+526311269992" style={{color:"black"}}><strong style={{color:"black"}}>Número de teléfono:</strong> 631-126-9992</a>
                
                </p>
                <p className="mt-4">
                  <span className="h4">Monica Lourdes Chacón Garcia:</span>
                  <br />{" "}
                  <a href="mailto:monicachacon@ipme.com.mx"><strong>Correo:</strong> monicachacon@ipme.com.mx</a><br></br>
                  <a href="tel:+526461504000" style={{color:"black"}}><strong style={{color:"black"}}>Número de teléfono:</strong> 646-150-4000</a>


                </p>
              </div>
              
            </Col>
            <Col lg="8">
              <div className="custom-form mt-4 pt-4">
                <p id="error-msg"></p>
                <div id="message"></div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}>
                  <Row>
                    <Col lg="6 mt-2">
                      <Input
                        name="name"
                        className=""
                        placeholder="Tu nombre"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name ? true : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                      ) : null}
                    </Col>
                    <Col lg="6 mt-2">
                      <Input
                        name="email"
                        className=""
                        placeholder="Tu correo"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12 mt-2">
                      <Input
                        name="subject"
                        className=""
                        placeholder="Asunto"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.subject || ""}
                        invalid={
                          validation.touched.subject && validation.errors.subject ? true : false
                        }
                      />
                      {validation.touched.subject && validation.errors.subject ? (
                        <FormFeedback type="invalid">{validation.errors.subject}</FormFeedback>
                      ) : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12 mt-2">
                      <div className="form-group">
                        <textarea
                          name="comments"
                          id="comments"
                          rows="4"
                          className="form-control"
                          placeholder="Tu mensaje..."
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.comments || ""}
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" className="text-end">
                      <Button className="submitBnt btn btn-primary">
                        {!cargando ? 'Enviar mensaje' : <ReactLoading type="cylon" width={50} />}
                      </Button>
                      <div id="simple-msg"></div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <div className="embed-responsive embed-responsive-16by9 mt-2">
              
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3487.9008119757073!2d-111.01214982448371!3d29.049514775439533!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjnCsDAyJzU4LjMiTiAxMTHCsDAwJzM0LjUiVw!5e0!3m2!1ses!2smx!4v1736371780093!5m2!1ses!2smx"
                width="100%"
                height="200px"
                className="embed-responsive-item "
                style={{ borderRadius: '12px', boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
}

export default ContactUs;
